import { Text } from '@interco/inter-ui/components/Text'

import LogoImage from '../../assets/png/logo.png'
import * as S from './PartnerLogo.styles'

export const PartnerLogo = () => (
  <S.PartnerLogo>
    <div>
      <Text variant="caption-2" colorWeight={500}>
        Um produto em parceria e emitido pela
      </Text>
      <img src={LogoImage} alt="Logo Brasilcap" />
    </div>
    <Text variant="caption-2">Este é um produto de Capitalização, não um investimento.</Text>
  </S.PartnerLogo>
)
